import { useState } from 'react';
import { Container, Image } from 'react-bootstrap';
import Empower1 from 'assets/img/landing/internetHub/empower1.jpeg';
import Empower2 from 'assets/img/landing/internetHub/empower2.jpeg';
import Empower3 from 'assets/img/landing/internetHub/empower3.jpeg';
import Empower4 from 'assets/img/landing/internetHub/empower4.jpeg';
import Empower5 from 'assets/img/landing/internetHub/empower5.jpeg';
import Empower6 from 'assets/img/landing/internetHub/empower6.jpeg';
import { EmpowerDetailsProp, PageDetailsProp } from './empower.type';
import { LandingRole } from 'pages/landing/main.type';

const pageDetails: Record<LandingRole, PageDetailsProp | null> = {
  student: {
    heading: {
      firstLine: 'Empower Your Tech Career',
      secondLine: 'Beyond Limits!'
    },
    description: {
      firstLine:
        'CRUD Beat is more than just a platform — it’s your gateway to ',
      secondLine: 'limitless career possibilities.'
    }
  },
  recruiter: {
    heading: {
      firstLine: 'Unique Ways CRUD Beat',
      secondLine: 'Empowers Recruiters'
    },
    description: {
      firstLine:
        'CRUD Beat revolutionizes hiring with innovative tools, streamlining talent discovery,',
      secondLine: 'assessment, and recruitment for forward-thinking recruiters.'
    }
  },
  college: {
    heading: {
      firstLine: 'Empower Your Tech Career',
      secondLine: 'Beyond Limits!'
    },
    description: {
      firstLine:
        'CRUD Beat is more than just a platform — it’s your gateway to ',
      secondLine: 'limitless career possibilities.'
    }
  },
  default: null
};
const emportDetails: Record<LandingRole, EmpowerDetailsProp[] | null> = {
  student: [
    {
      img: Empower1,
      title: 'Global Tech Exposure',
      description:
        'Compete in global coding contests and build a global career profile.'
    },
    {
      img: Empower2,
      title: 'Exclusive Tech Championships',
      description:
        'Earn global rankings, awards, and life-changing career opportunities.'
    },
    {
      img: Empower3,
      title: 'Industry Networking Events',
      description:
        'Build lasting connections with industry leaders and innovators.'
    },
    {
      img: Empower4,
      title: 'Career-Focused Bootcamps',
      description: 'Enroll in bootcamps led by tech experts.'
    },
    {
      img: Empower5,
      title: 'Real-World Project Collaborations',
      description:
        'Gain practical experience and build an impressive project portfolio.'
    },
    {
      img: Empower6,
      title: 'Personalized Career Mentorship',
      description:
        'Get tailored career paths, resume reviews, and interview coaching.'
    }
  ],
  recruiter: [
    {
      img: Empower1,
      title: 'Conduct Virtual Job Fairs',
      description: 'Host virtual job fairs for interviews and hiring.'
    },
    {
      img: Empower2,
      title: 'Exclusive Tech Championships',
      description:
        'Earn global rankings, awards, and life-changing career opportunities.'
    },
    {
      img: Empower3,
      title: 'Industry Networking Events',
      description:
        'Build lasting connections with industry leaders and innovators.'
    },
    {
      img: Empower4,
      title: 'Career-Focused Bootcamps',
      description: 'Enroll in bootcamps led by tech experts.'
    },
    {
      img: Empower5,
      title: 'Real-World Project Collaborations',
      description:
        'Gain practical experience and build an impressive project portfolio.'
    },
    {
      img: Empower6,
      title: 'Personalized Career Mentorship',
      description:
        'Get tailored career paths, resume reviews, and interview coaching.'
    }
  ],
  college: [
    {
      img: Empower1,
      title: 'Create a Tech Talent Hub',
      description:
        'Establish your institution as a tech innovation center. Showcase student projects, achievements, and campus events globally.'
    },
    {
      img: Empower2,
      title: 'Launch Branded Hackathons & Competitions',
      description:
        'EHost national and international coding contests.Gain recognition by organizing tech challenges and innovation contests.'
    },
    {
      img: Empower3,
      title: 'Partner with Global Tech Leaders',
      description:
        'Collaborate with leading tech companies for internships and live projects.Facilitate corporate tie-ups for research, development, and sponsorships.'
    },
    {
      img: Empower4,
      title: 'Drive Alumni Engagement & Mentorship',
      description:
        'Connect students with successful alumni for mentorship and career guidance. Organize alumni-led webinars, workshops, and tech talks.'
    },
    {
      img: Empower5,
      title: 'Host Career & Placement Fairs',
      description:
        'Organize large-scale virtual and on-campus placement drives. Bring recruiters and students together under one digital roof.'
    },
    {
      img: Empower6,
      title: 'Conduct Industry-Integrated Bootcamps',
      description:
        'GOffer career-focused bootcamps in emerging tech fields like AI, ML, and Cloud Computing.Collaborate with industry experts for real-world project experience.'
    }
  ],
  default: null
};
const Empower = ({ role }: { role: LandingRole }) => {
  const [currentId, setCurrentId] = useState<number>(0);
  const titleDetails: PageDetailsProp | null = pageDetails[role];
  const contentDetails: EmpowerDetailsProp[] | null = emportDetails[role];
  return (
    <Container fluid className="p-lg-9 py-10">
      <p className="fs-5 fw-bold leading-2">
        {titleDetails?.heading.firstLine} <br />
        {titleDetails?.heading.secondLine}
      </p>
      <p className="text-body-secondary pb-5">
        {titleDetails?.description.firstLine} <br />
        {titleDetails?.description.secondLine}
      </p>
      <div className="empower d-flex gap-3 position-relative">
        {contentDetails?.map((empower, idx) => {
          const isActive = idx === currentId;
          return (
            <div key={`card-${idx}`} className="empower_card g-3">
              <div
                className={`empower_card_inner ${isActive ? 'active' : ''}`}
                onClick={() => setCurrentId(idx)}
              >
                <div className="d-flex flex-column align-items-center">
                  <Image
                    src={empower?.img}
                    alt={empower?.title}
                    className={`empower-image ${isActive ? 'active' : ''}`}
                    fluid
                  />
                </div>

                <div
                  className={`description-container bg-primary text-secondary-subtle position-absolute w-100 ${
                    isActive ? 'active' : ''
                  }`}
                >
                  <p className="fs-7 fw-bold">{empower?.title}</p>
                  <p>{empower?.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default Empower;
